import $ from 'jquery';
import { featureDecisions } from 'Modules/feature-flags';

import vimeoPlayerWidget from '../../../Widgets/ui/VideoPlayer/vimeoPlayer';
import blockedVideoWidget from '../../../Widgets/ui/VideoPlayer/blockedVideoPlayer';
import mediaMatchService from '../../../Services/Media/mediaMatch';
import mediaVideoService from '../../../Services/Media/video';
import videoConstants from '../../../Services/Media/Video/constants';

const factory = {};

let videoCount = 0;

factory.create = async function (element, options) {
  var widget = null,
    $element = $(element),
    blockedVideo = $element.data('blockedVideo');

  if (!$element.is('video')) {
    return null;
  }

  options = options || {};

  if (blockedVideo) {
    options.elementWrapper = blockedVideo.elementWrapper;
    widget = blockedVideoWidget.create(options, $element);
  } else if (
    mediaMatchService.getTypeFromUrl($element.attr('src')) === videoConstants.VIDEO_TYPE_VIMEO
  ) {
    if (featureDecisions.isCustomVideoPlayerEnabled()) {
      const $simpleDiv = $(`<div id="${element.id}"/>`);
      const videoUrl = element.src;
      $(element).replaceWith($simpleDiv);

      const { createVideoPlayer } = await import(
        /* webpackChunkName: "videoPlayer" */ 'Modules/videoPlayer'
      );

      createVideoPlayer({
        id: videoCount,
        element: $simpleDiv.get(0),
        url: videoUrl,
        claireReferenceId: parseInt(element.id.slice(2), 10),
        sourceUrl:
          'https://player.vimeo.com/external/107603629.m3u8?s=59030bdefc2f01ba9660fd0d7fe4c248aaa644bf',
      });
    } else {
      widget = vimeoPlayerWidget.create(options, $element);
    }
  } else {
    mediaVideoService.videoToIframe($element);
  }

  videoCount++;
  return widget;
};

export default factory;
